import { TWO_PI } from "./core";

/**
 * The standard ANGLE_EPSILON is generally too small for this module.
 */
const LARGE_ANGLE_EPSILON = 0.00001;

/**
 * Clean an angle to be within the range of 0 to some number of radians (the quotient).
 * Defaults to a quotient of 2 * PI (360 degrees).
 */
export function angleClean(angle: number, quotient = TWO_PI, tolerance = LARGE_ANGLE_EPSILON): number {
  if (Math.abs(quotient) < tolerance) {
    return angle;
  }

  let remainder = angle / quotient;
  const rounded = Math.round(remainder);
  if (Math.abs(rounded - remainder) < tolerance) {
    remainder = rounded;
  }
  if (remainder >= 1 - tolerance) {
    return angle - Math.floor(remainder) * quotient;
  }
  if (remainder <= -1 + tolerance) {
    return angle - Math.ceil(remainder) * quotient;
  }
  return angle;
}

/**
 * Checks if two angles are equal modulo some value (defaulting to 2*PI).
 */
export function angleValuesSame(a: number, b: number, modulo = TWO_PI, tolerance = LARGE_ANGLE_EPSILON): boolean {
  // Normalize both angles to the range of 0 to modulo
  const aNormalized = angleClean(a, modulo);
  const bNormalized = angleClean(b, modulo);
  return Math.abs(aNormalized - bNormalized) < tolerance;
}
